module.exports = __webpack_public_path__ + "img/world-map.62b08c6f.svg";